/** Phase 20 */
import { getAggregateUserInfo } from '../infrastructure/storage/domainAggregateStore';
import { getEntityUserInfo } from '../infrastructure/storage/entityAggregateStore';
import { createRootDocumentEntityReadSource } from './rootDocumentEntityReadSourceFactory';

const source = createRootDocumentEntityReadSource({
  field: 'userInfo',
  getEntity: getEntityUserInfo,
  getAggregate: getAggregateUserInfo,
  emptyValue: null
});

export const readUserInfoFromMergedBlob = source.readFromMergedBlob;
export const readUserInfoFromBestSource = source.readFromBestSource;
export const refreshUserInfoReadCache = source.refreshReadCache;
export const getCachedUserInfoRead = source.getCachedRead;
export const clearUserInfoReadCache = source.clearReadCache;
export const readUserInfoSyncForBusiness = source.readSyncForBusiness;
